import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

// A deferred is a promise wrapper that allows us
// to programmatically mark acceptance or rejection of a promise
// Similar to jQuery's $.deferred
var Deferred = function Deferred() {
  var _this = this;

  _classCallCheck(this, Deferred);

  _defineProperty(this, "resolve", function () {});

  _defineProperty(this, "reject", function () {});

  _defineProperty(this, "promise", new Promise(function (resolve, reject) {
    _this.resolve = resolve;
    _this.reject = reject;
  }));

  _defineProperty(this, "then", this.promise.then.bind(this.promise));

  _defineProperty(this, "catch", this.promise.catch.bind(this.promise));
};

export { Deferred as default };